import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AddProductComponent } from './add-product/add-product.component'
import { EmptyCartComponent } from './empty-cart/empty-cart.component'
import { QuoteCartProductComponent } from './quote-cart-product/quote-cart-product.component'
import { ViewCartComponent } from './view-cart/view-cart.component'
import { ConfigModule, I18nModule, provideConfig } from '@spartacus/core'
import { RouterModule } from '@angular/router'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { DIALOG_TYPE, MediaModule, SpinnerModule } from '@spartacus/storefront'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatTooltipModule } from '@angular/material/tooltip'
import { DeleteCartDialogComponent } from './delete-cart-dialog/delete-cart-dialog'
import { NgSelectModule } from '@ng-select/ng-select'
import { InventoryAvailabilityDialogComponent } from './inventory-availability-dialog/inventory-availability-dialog.component'
import { FasttrackQuoteDialogComponent } from './fasttrack-quote-dialog/fasttrack-quote-dialog.component'
import { SavedQuoteCartDialogComponent } from './saved-quote-cart-dialog/saved-quote-cart-dialog.component'
import { QuantityCounterModule } from '../../../shared/components/quantity-counter'
import { ClickOutsideModule } from '../../../shared/directive/clickOutside/click-outside.module'
import { DatePickerModule } from '../../../shared/components/date-picker/date-picker.module'
import { environment } from '../../../../environments/environment'
import { VS_LAUNCH_CALLER } from '../../config/dialog.config'

@NgModule({
  declarations: [
    AddProductComponent,
    EmptyCartComponent,
    QuoteCartProductComponent,
    ViewCartComponent,
    DeleteCartDialogComponent,
    InventoryAvailabilityDialogComponent,
    FasttrackQuoteDialogComponent,
    SavedQuoteCartDialogComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    FormsModule,
    ReactiveFormsModule,
    MediaModule,
    MatExpansionModule,
    SpinnerModule,
    MatSnackBarModule,
    MatTooltipModule,
    QuantityCounterModule,
    RouterModule,
    ClickOutsideModule,
    DatePickerModule,
    NgSelectModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['quoteCart'],
        },
      },
    }),
  ],
  exports: [QuoteCartProductComponent],
  providers: [
    provideConfig({
      launch: {
        [VS_LAUNCH_CALLER.DELETE_QUOTE_CART]: {
          inlineRoot: true,
          component: DeleteCartDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.FASTTRACK_QUOTE]: {
          inlineRoot: true,
          component: FasttrackQuoteDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.INVENTORY_AVAILABILITY]: {
          inlineRoot: true,
          component: InventoryAvailabilityDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.SAVED_QUOTE_CART]: {
          inlineRoot: true,
          component: SavedQuoteCartDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
})
export class QuoteCartModule {}
